import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesPreClientVerificationComponent} from "./sales-pre-client-verification.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";



@NgModule({
  declarations: [
    SalesPreClientVerificationComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    SalesPreClientVerificationComponent
  ]
})
export class SalesPreClientVerificationModule { }
